// extracted by mini-css-extract-plugin
export default {"labelTitle":"SlideContent_labelTitle__4KcrA","title":"SlideContent_title__ztsOX","text":"SlideContent_text__2ur-L","ctaWrapper":"SlideContent_ctaWrapper__ZZR-6"};